/**
 * @ngdoc directive
 * @name ce-app:CheckImageDirective
 *
 * @description
 *
 *
 * @restrict A
 * */
/* @ngInject */
export default function CheckImageDirective($http) {
    return {
        restrict: 'A',
        scope: {
            name: '=',
            defSrc: '=',
            fullPath: '=',
            dirPath: '='
        },
        link: function (scope, elem) {
            scope.createImageSource = function () {
                if (scope.name) {
                    scope.filename = scope.name
                        .replace(/\s+/g, '-')
                        .replace('&', 'and')
                        .replace('(', '')
                        .replace(')', '')
                        .toLowerCase() + '.png';
                    scope.path = scope.dirPath + scope.filename;
                } else if (scope.fullPath && !scope.name) {
                    scope.path = scope.fullPath;
                }
            };

            scope.testImageServability = function () {
                scope.createImageSource();

                $http({method: 'GET', url: scope.path}).then(function () {
                    //image exists
                    elem.attr('src', scope.path);
                })['catch'](function () {
                    //image doesn't exist
                    elem.attr('src', scope.defSrc);
                });
            };

            scope.testImageServability();
        }
    };
}
